import * as React from 'react'
import { message, notification } from 'antd'
import * as api from '@services/api.tsx'

export class ComponentExt<P = {}, S = {}> extends React.Component<P, S> {
    readonly api = api
    readonly $message = message
    readonly $notification = notification
}

export class StoreExt {
    protected readonly _api = api
    protected readonly _$message = message
    protected readonly _$notification = notification

    get api() {
        return this._api
    }

    get $message() {
        return this._$message
    }

    get $notification() {
        return this._$notification
    }
}
